module.exports = __webpack_public_path__ + "img/LaunchPAD Icon.a1541f08.svg";